// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function anchor3_viewportEnter(event) {
	$w("#columnStrip5").show();

$w("#columnStrip4").hide();
$w("#shoppingCartIcon1").hide();
$w("#shoppingCartIcon2").show();

 
}

export function anchor3_viewportLeave(event) {
	//Add your code for this event here: 
	$w("#columnStrip4").show();
	$w("#columnStrip5").hide();
	$w("#shoppingCartIcon2").hide();
	$w("#shoppingCartIcon1").show();


}